/**
 * roundFormDeriveCents
 *
 * Half AWAY from zero, applied ONCE to a derive's final value so client, server
 * and stamp guard all see one number. A DIFFERENT symbol from the grammar's
 * `roundToCents`, which keeps its binary-float behavior; shifting the ES
 * shortest-round-trip decimal by an exponent avoids `1.005 * 100 = 100.4999…`.
 * Two boundaries: past `|value| > 2^53 / 100` a cent is under one ulp and the
 * input returns unchanged; and a zero result is normalized to POSITIVE zero,
 * since Firestore reads `-0` back as `0` and the guard would rewrite forever.
 */

/** Shifts a decimal representation by a power of ten without binary multiplication. */
function shiftDecimal(text: string, shift: number): number {
  const [mantissa, exponent = '0'] = text.toLowerCase().split('e');
  return Number(`${mantissa}e${Number(exponent) + shift}`);
}

function roundFormDeriveCents(value: number | null): number | null {
  if (value === null || !Number.isFinite(value)) return null;
  const sign = value < 0 ? -1 : 1;
  const magnitude = Math.abs(value);
  const scaled = Math.round(shiftDecimal(String(magnitude), 2));
  if (!Number.isSafeInteger(scaled)) return value;
  const rounded = sign * shiftDecimal(String(scaled), -2);
  return rounded === 0 ? 0 : rounded;
}

export { roundFormDeriveCents };
